import {
  catalogResponseSchema,
  type CatalogResponse,
  type CatalogFilters,
} from '../types';
import {
  authFetch, buildApiUrl 
} from '@/lib/api-client';

/**
 * Fetch catalog items with optional filters.
 */
export async function getCatalogItems(
  filters?: CatalogFilters
): Promise<CatalogResponse> {
  const params = new URLSearchParams();

  if (filters?.category) {
    params.set('category', filters.category);
  }
  if (filters?.search) {
    params.set('search', filters.search);
  }
  if (filters?.limit) {
    params.set('limit', String(filters.limit));
  }

  const url = buildApiUrl('/v1/catalog/items', params.toString() ? params : undefined);
  const response = await authFetch(url);

  if (!response.ok) {
    throw new CatalogApiError(
      response.status,
      `Failed to fetch catalog items: ${response.statusText}`
    );
  }

  const data: unknown = await response.json();
  return catalogResponseSchema.parse(data);
}

/**
 * Custom error class for catalog API errors.
 */
export class CatalogApiError extends Error {
  constructor(
    public readonly statusCode: number,
    message: string
  ) {
    super(message);
    this.name = 'CatalogApiError';
  }
}
